import React from 'react';
import Info from '../../info';

const UserProfileRightBottomPanel = (props) => {
  return props.updateOrView && props.updateOrView == 'view' ? (
    ''
  ) : (
    <Info
      paragraphs={[
        APP.LANGUAGE.UserProfile.InfoSectionName,
        APP.LANGUAGE.UserProfile.InfoSectionNamePartTwo,
        APP.LANGUAGE.UserProfile.InfoSectionNamePartThree,
      ]}
      moreInfoLink={APP.EXTERNAL_LINKS.UserProfile.MoreInfo}
    />
  );
};
export default UserProfileRightBottomPanel;
